import { render, staticRenderFns } from "./newCoupon.vue?vue&type=template&id=db6bd490&scoped=true"
import script from "./newCoupon.vue?vue&type=script&lang=js"
export * from "./newCoupon.vue?vue&type=script&lang=js"
import style0 from "./newCoupon.vue?vue&type=style&index=0&id=db6bd490&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db6bd490",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Prod-五域创客/jh-5eck-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('db6bd490')) {
      api.createRecord('db6bd490', component.options)
    } else {
      api.reload('db6bd490', component.options)
    }
    module.hot.accept("./newCoupon.vue?vue&type=template&id=db6bd490&scoped=true", function () {
      api.rerender('db6bd490', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/platformManage/platformCouponManage/newCoupon.vue"
export default component.exports